/*
 * @Description: 配置参数
 * @Author: 琢磨先生
 * @Date: 2022-05-09 21:46:47
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2025-03-10 00:04:32
 */

export default {
  /**
   * api请求host地址
   */
  HOST: "https://api.qda.itxiangtian.cn",
  /**
   * 本地缓存token名称
   */
  TOKEN: "token",

  /**
   * 应用编码
   */
  APP_CODE: "admin",
  /**
   * 项目app key
   */
  APP_KEY: "admin_pc",
  /**
   * 接口KEY
   */
  API_KEY: "admin_api",
  /**
   * API权限数据本地存储Key
   */
  API_STORE_KEY: "api_store_key",

  /**
   * 当前url地址对象
   */
  CURRENT_META_KEY:'current_meta_key',
};
